'use strict';

function scorePassword(pass) {
    let score = 0;
    if (!pass)
        return score;

    // award every unique letter until 5 repetitions
    const letters = new Object();
    for (let i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 7 / letters[pass[i]];
    }

    // bonus points for mixing it up
    const variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
    };

    let variationCount = 0;
    for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;
    let scoreAsInt = parseInt(score);
    return scoreAsInt > 100 ? 100 : scoreAsInt;
}

function passwordStrength(pass) {
    const score = scorePassword(pass);
    let scoreInWords = '';
    if (score > 80)
        scoreInWords = "strong";
    else if (score > 50)
        scoreInWords = "good";
    else if (score >= 30)
        scoreInWords = "weak";

    return { score, scoreInWords }
}

module.exports = {
    scorePassword,
    passwordStrength
};


// WEBPACK FOOTER //
// ./client/helpers/password-strength.js